import { c as _c } from "react/compiler-runtime";
import { type BadgeColor } from '@precis-digital/kurama/Badge';
import Grid from '@precis-digital/kurama/Grid';
import Tooltip from '@precis-digital/kurama/Tooltip';
import Chip from '@precis-digital/kurama/Chip';
import { DEFINED_MODELS_FOR_LEGEND } from 'src/attributionModelV2/constants';
import { useTranslation } from 'shared/translations';
import { objectKeys } from 'shared/utils';
export interface ChartLegendProps {
  selectedRecords: Record<string, {
    badgeColor: BadgeColor;
    opacity?: number;
  }>;
}
const ChartLegend = t0 => {
  const $ = _c(6);
  const {
    selectedRecords
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "dashboard"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("attributionModelV2", t1);
  let t2;
  if ($[1] !== selectedRecords || $[2] !== t) {
    t2 = objectKeys(selectedRecords).map(key => {
      const badgeColor = selectedRecords[key].badgeColor;
      const opacity = selectedRecords[key].opacity;
      const chipElement = <Chip badgeProps={{
        color: badgeColor,
        opacity
      }} key={key} label={key} />;
      const model = DEFINED_MODELS_FOR_LEGEND.find(m => m.label === key);
      return model != null ? <Tooltip kind="multiline" placement="right" title={key} body={t(`tooltipText.${model.value}`)}>{chipElement}</Tooltip> : chipElement;
    });
    $[1] = selectedRecords;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Grid container={true} gap="13px">{t2}</Grid>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default ChartLegend;